module.exports = __webpack_public_path__ + "img/icon_info.d3c86436.svg";